import SectionHeading from "../common/SectionHeading";
import { Reveal, StaggerGroup, StaggerItem } from "../common/Reveal";
import { Icon } from "../../lib/icon";
import { trustFeatures } from "../../data/site";

export default function TrustSection() {
  return (
    <section className="relative px-6 py-24 lg:py-32" data-testid="trust-section">
      <div className="mx-auto max-w-7xl">
        <SectionHeading
          eyebrow="Why AMVI"
          title="Technology Expertise. Industry Knowledge. Talent That Delivers."
          subtitle="We bring together deep technology capability and specialized talent, aligned to the way your industry actually works."
          testId="trust"
        />

        <StaggerGroup className="mt-16 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {trustFeatures.map((f, i) => (
            <StaggerItem
              key={f.title}
              className={i === 0 ? "sm:col-span-2 lg:col-span-1" : ""}
            >
              <div className="group h-full rounded-2xl border border-white/10 bg-ink-800/40 p-8 transition-all duration-500 hover:-translate-y-1 hover:border-sky-400/40">
                <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-sky-400 transition-colors duration-500 group-hover:text-sky-300">
                  <Icon name={f.icon} className="h-6 w-6" />
                </div>
                <h3 className="font-heading text-lg font-bold tracking-tight text-white">
                  {f.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{f.description}</p>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
